(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-marketing/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/grassroots-marketing/assets/javascripts/init.js');

'use strict';

const ApiProvider = window.RTKQ.ApiProvider;
const Marketing = svs.grassroots.pages.Marketing;
const grassrootsQueryApi = svs.grassroots.store.grassrootsQueryApi;
const _svs$app$ReactRouter = svs.app.ReactRouter,
  PlayerRouter = _svs$app$ReactRouter.PlayerRouter,
  Route = _svs$app$ReactRouter.Route;
const baseUrl = svs.core.data.baseUrl;
ReactDOM.render(React.createElement(ApiProvider, {
  api: grassrootsQueryApi
}, React.createElement(PlayerRouter, {
  basename: baseUrl,
  withRouter: true
}, React.createElement(Route, {
  exact: true,
  path: "/",
  render: () => React.createElement(Marketing, null)
}))), document.querySelector('.receivers-app'));

 })(window);